import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]

import * as echarts from "echarts";
import {EChartsType} from "echarts/core";
import {onMounted,watch} from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'bar',
  props: {
  className: {
    type: String,
    default: 'chart'
  },
  config:{
    type: Object,
    default: ()=>{}
  },
  id: {
    type: String,
    default: 'chart'
  },
  width: {
    type: String,
    default: '200px'
  },
  height: {
    type: String,
    default: '200px'
  },
  xdata:{
    type:Array,
    default:()=>[]
  },
  ydata:{
    type:Array,
    default:()=>[]
  },
  chartData:{
    type:Array,
    default:()=>[]
  },
  isYValue:{
    type: Boolean,
    default: true
  },
  max:{
    type:Number
  }
},
  setup(__props) {

let props = __props

let chart:EChartsType;
const initChart =()=> {
  let chart = echarts.init(document.getElementById(props.id))
  console.log(props.max)
  let options = {
    tooltip:{
      show:true,
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      }
    },
    grid: {
      top: 10,
      left: '2%',
      right: '2%',
      bottom: '2%',
      containLabel: true
    },
    xAxis: {
      type: props.isYValue?'category':'value',
      data: props.xdata,
      axisLabel:{
        interval:0,
        width:60,
        overflow:'truncate',
        ellipsis:'...'
      },
    },
    yAxis: {
      type: props.isYValue?'value':'category',
      data:props.ydata,
      max:props.isYValue?props.max:'',
      axisLabel:{
        interval:0,
        width:50,
        overflow:'truncate',
        ellipsis:'...'
      },
    },
    series: [
      {
        data: props.chartData,
        barWidth:30,
        type: 'bar',
        itemStyle: {
          normal: {
            color:echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: '#7DE3FF',
              },
              {
                offset: 1,
                color: '#1B72FF',
              },
              ]
            )
          }
        }
      }
    ]
  };
  chart.setOption(options)
  return chart
}
watch(
  ()=>props.chartData,
  (newList,oldList)=>{
    let chart = initChart()
    chart&&chart.resize()
  },
  {deep:true}
)
onMounted(()=>{
  let chart = initChart()
  window.addEventListener('resize',function (){
    chart&&chart.resize()
  })

})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: __props.id,
    class: _normalizeClass(__props.className),
    style: _normalizeStyle({height:__props.height,width:__props.width})
  }, null, 14, _hoisted_1))
}
}

})